// extracted by mini-css-extract-plugin
module.exports = {"pagination":"style_pagination__1l6B7","text":"style_text__1ktPu","active":"style_active__Osq8x","arrow":"style_arrow__2ctmu"};